<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true"
				label-width="100px" :rules="rules">
				<el-row>
					<el-col :span="12">
						<el-form-item label="试题类型" prop="type">
							<select-option-dictionary v-model="formParameter.type" dkey="exam-types"
								:disabled="bjdisabled">
							</select-option-dictionary>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="科 目" prop="sbid">
							<el-input placeholder="请选择科目" disabled v-model="formParameter.sbname">
								<template slot="append">
									<el-button type="primary" @click="selectSub()">选择</el-button>
								</template>
							</el-input>
							<el-input v-model="formParameter.sbid" v-show="false"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="关键字" prop="keyword">
							<el-input v-model="formParameter.keyword" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="考 点" prop="examingPoint">
							<el-input v-model="formParameter.examingPoint" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>

				</el-row>
				<el-row>
					<el-col :span="11">
						<el-form-item label="快速查重" prop="">
							<el-autocomplete class="inline-input" v-model="keyword"
								:fetch-suggestions="querySearchQN" placeholder="根据输入关键字快速查询重题"
								@select="handleSelectQN" :trigger-on-focus="false"></el-autocomplete>
							<el-button @click="clearKw()">清除</el-button>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="来 源" prop="reference">
							<select-option-dictionary v-model="formParameter.reference"
								dkey="exam-reference">
							</select-option-dictionary>
						</el-form-item>
					</el-col>
					<el-col :span="7">
						<el-form-item label="难度" prop="easy">
							<el-rate v-model="formParameter.easy"></el-rate>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="星级" prop="level">
							<el-rate show-text :texts="rateTexts" v-model="formParameter.level"></el-rate>
						</el-form-item>
					</el-col>
					<el-col :span="14">
						<el-form-item label="文摘" prop="easy">
							<el-select v-model="formParameter.vdoid" @change="selectDoc" clearable
								placeholder="请选择文摘">
								<el-option v-for="itm in doces" :key="itm.id" :label="itm.title"
									:value="itm.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="2">
						<a :href="doc.url" v-show="doc.url" target="_blank">
							<el-button size="mini">打开</el-button>
						</a>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="题 目" prop="name">
							<el-input v-if="formParameter.type == 4"
								placeholder="填空项使用【【】】占位，注意：不能在首尾使用【【】】!" type="textarea"
								:autosize="{ minRows: 3 }" v-model="formParameter.name">
							</el-input>
							<el-input v-else type="textarea" :autosize="{ minRows: 3 }"
								v-model="formParameter.name">
							</el-input>

						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="22">
						<el-form-item label="题目解析" prop="analysis">
							<div v-if="disabled" v-html="formParameter.analysis"></div>
							<el-input v-else :rows="12" type="textarea" v-model="formParameter.analysis"
								autocomplete="off">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="2">
						<el-button size="mini" @click="sendToAgent">同步</el-button>
					</el-col>
				</el-row>
				<!-- -----------单选题----------- -->
				<template v-if="(formParameter.type) == 1">
					<el-divider content-position="left">单选题</el-divider>
					<!-- 单选题选项 -->
					<el-row v-for="(item, index) in options" v-bind:key="index">
						<el-col :span="24">
							<el-form-item :label="item.o">
								<el-input v-model="item.n">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<!-- 单选题答案 -->
					<el-row>
						<el-col :span="24">
							<el-form-item label="答案" prop="answer">
								<el-radio-group v-model="formParameter.answer" v-if="!disabled">
									<el-radio label="A"></el-radio>
									<el-radio label="B"></el-radio>
									<el-radio label="C"></el-radio>
									<el-radio label="D"></el-radio>
								</el-radio-group>
								<div v-show="disabled">{{ daAn }}</div>
							</el-form-item>
						</el-col>
					</el-row>
				</template>
				<!-- 多选题 -->
				<template v-else-if="(formParameter.type) == 2">
					<el-divider content-position="left">多选题</el-divider>
					<!-- 多选题选项 -->
					<el-row v-for="(item, index) in options" v-bind:key="index">
						<el-col :span="24">
							<el-form-item :label="item.o">
								<el-input v-model="item.n">

								</el-input>
								<el-button type="primary" icon="el-icon-circle-plus-outline"
									v-show="(options.length - 1) == index"
									@click="addSelectItem()"></el-button>
								<el-button type="primary" icon="el-icon-remove-outline"
									v-show="(options.length - 1) == index"
									@click="removeSelectItem()"></el-button>
							</el-form-item>
						</el-col>
					</el-row>

					<!-- 多选题答案 -->
					<el-row>
						<el-col :span="24">
							<el-form-item label="答案" prop="answer">
								<el-checkbox-group v-model="checkList" v-show="!disabled">
									<el-checkbox v-for="(item, index) in options" v-bind:key="index"
										:label="item.o">
									</el-checkbox>
								</el-checkbox-group>
								<div v-show="disabled">{{ daAn }}</div>
							</el-form-item>
						</el-col>
					</el-row>
				</template>
				<template v-else-if="(formParameter.type) == 3">
					<el-divider content-position="left">判断题</el-divider>

					<el-row>
						<el-col :span="24">
							<el-form-item label="答案">
								<el-radio-group v-model="formParameter.answer" size="medium">
									<el-radio border label="正确"></el-radio>
									<el-radio border label="错误"></el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
					</el-row>
				</template>
				<template v-else-if="(formParameter.type) == 4">
					<el-divider content-position="left">填空题</el-divider>
					<el-row>
						<el-col :span="24">
							<el-form-item label="是否有序：" prop="isSort">
								<el-radio-group v-model="formParameter.isSort">
									<el-radio label="true">是</el-radio>
									<el-radio label="false">否</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row v-for="(item1, index) in answerNum" v-bind:key="index">
						<el-col :span="24">
							<el-form-item :label="'答案' + item1.o">
								<el-input v-model="item1.n"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<br />
				</template>
				<template v-else>
					<el-divider content-position="left">简答题、论述题、编程题</el-divider>

					<!-- <el-row>
						<el-col :span="24">
							<el-form-item label="试题内容" prop="name">
								<el-input type="textarea" :rows="3" v-model="formParameter.name" autocomplete="off"
									placeholder="请输题目" :autosize="{ minRows: 3}">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row> -->
					<!-- 简答题 -- 答案填写   --答案回显 -->
					<el-row v-if="this.title != '详情'">
						<el-col :span="24" v-if="(formParameter.type) == 5">
							<el-form-item label="答案" prop="answer">
								<el-input type="textarea" :rows="6" v-model="formParameter.answer"
									autocomplete="off" placeholder="请输入答案" :autosize="{ minRows: 6 }">
								</el-input>
							</el-form-item>
						</el-col>
						<!-- ----------编程题、逻辑题----------- -- 答案填写 -->
						<el-col :span="24" v-if="(formParameter.type) > 5">
							<el-form-item label="答案" prop="answer">
								<wangEditQu v-model="formParameter.answer">
								</wangEditQu>
							</el-form-item>
						</el-col>
					</el-row>
					<!-- 答案回显 -->
					<!-- 简答题 -- 答案 -->
					<el-row v-else>
						<el-col :span="24" v-if="(formParameter.type) == 5">
							<el-form-item label="答案" prop="answer">
								<el-input type="textarea" :rows="6" v-model="formParameter.answer"
									autocomplete="off">
								</el-input>
							</el-form-item>
						</el-col>
						<!-- 编程题、逻辑题 -- 答案 -->
						<el-col :span="24" v-if="(formParameter.type) > 5">
							<el-form-item label="答案" prop="answer">
								<div v-html="formParameter.answer" class="content-html"></div>
							</el-form-item>
						</el-col>
					</el-row>

				</template>
				<el-dialog title="选择绑定科目" :visible.sync="dialogVisibleKm" width="60%" :append-to-body="true">
					<tree class="filter-tree" ref="permissionTree" check-strictly :items="permissionList"
						:data="permissionList" :defaultParent="0" @nodeClick="treeClick"
						:expand-on-click-node="true">
					</tree>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisibleKm = false">取 消</el-button>
						<el-button type="primary" @click="comfirmSub">确 定</el-button>
					</span>
				</el-dialog>
			</el-form>
		</div>

		<div slot="footer">
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确
				定</el-button>
			<el-button @click="close">取 消</el-button>
		</div>
	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/exams/question/question.js';
import wangEditQu from "@/components/wangEdit/wangEditQu.vue";
import subApi from "@/api/edu/subject/subject.js";
import tree from "@/components/tree/tree.vue";
import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue';
 

export default {
	name: 'edit',
	components: {
		popup,
		selectOptionDictionary,
		wangEditQu,
		tree
	},
	data() {
		return {
			subData: [],
			dialogVisibleKm: false,
			treeRef: "permissionTree",
			treeExpand: false,
			permissionList: [],

			keyword: "", //查询重复题的关键字
			doces: [],  //文摘备选
			doc: {},  //当前文摘

			currentNode: {},
			rateTexts: ["废弃", "重复", "一般题", "重点题", "面试热点题"],
			title: '',
			bjdisabled: false,
			daAn: '',
			radio: 1,
			checkList: [],
			menus: [],
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			parameter: {},
			options: [
				{ o: 'A', n: '' },
				{ o: 'B', n: '' },
				{ o: 'C', n: '' },
				{ o: 'D', n: '' }],
			formParameter: { answer: '', type: 1, reference: '自编题' },
			isSort: "true",

			answerNum: [
				//	{o: '1',n: ''}     
			],                   //填空题的答案输入框
			answerLen: 0,        //填空题的答案数量

			rules: {
				name: [
					{ required: true, message: '请填写试题内容', trigger: 'blur' }
				],
				answer: [
					{ required: true, message: '请填写答案', trigger: 'blur' }
				],


			}

		};
	},
	watch: {
		"formParameter.type": function (newVal, oldVal) {

			if (this.title == '添加') {
				if (newVal < 5) {
					// this.formParameter.isSubjective=1;
					this.formParameter = { answer: '', type: newVal, reference: '自编题' };
				} else {
					// this.formParameter.isSubjective = 2;
					this.formParameter = { answer: '', type: newVal, reference: '自编题' };
				}
			}
		}, "formParameter.name": function (newVal, oldVal) {
			//填空题
			if (this.formParameter.type * 1 == 4) {
				//   console.log(newVal)
				//数一下formParameter.name 有多少  
				if (newVal) {
					let newValArr = newVal.split("【【】】")

					// console.log( " 添加一个 ",newVal)

					if (newValArr.length > 1) {

						if (newValArr.length != this.answerLen) {
							this.answerLen = newValArr.length
							this.answerNum = []  //reset

							for (let i = 0; i < newValArr.length - 1; i++) {
								this.answerNum.push({ o: i + 1, n: '' })
							}
							//console.log("this.answerNum", this.answerNum)
							this.$forceUpdate()
						}
					} else {
						this.answerNum = []
					}


				}
			}

		},

		"checkList": function (newVal, oldVal) {

			let str = '';
			for (let index = 0; index < newVal.length; index++) {
				if (index != newVal.length - 1) {
					str = str + newVal[index] + ',';
				} else {
					str = str + newVal[index]
				}
			}
			this.formParameter.answer = str;
		},
	},
	methods: {
		sendToAgent() {
			
			this.$prompt('选择题可能问智能体的题目名称需要调整：', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputType: 'textarea',
				inputPlaceholder: '请输入内容',
				inputValue: this.formParameter.name,
				customClass: 'agent-sync-dialog',
			}).then(({ value }) => {

				api.updtAnysFrAgent({ qid: this.formParameter.id, title: value }, res => { 
					this.$set(this.formParameter, 'analysis', res.msg)
				})

			}).catch(() => {});
		},
		selectDoc(vid) {
			if (vid) {
				this.doc = this.doces.filter(v => { return v.id == vid })[0]
				//console.log("this.doc ", this.doc)
			}

		},

		querySearchQN(queryStr, cb) {
			//发起查询
			api.intionlist({ name: queryStr }, res => {
				let listQues = res.data
				var results = queryStr ? listQues.filter(this.createFilterQN(queryStr)) : listQues;
				// 调用 callback 返回建议列表的数据
				cb(results);
			})
		},
		createFilterQN(queryStr) {
			return (listQues) => {
				return (listQues.value.indexOf(queryStr) >= 0);
			};
		},
		handleSelectQN(item) {
			api.toUpdate({ id: item.id }, res => {
				//回显名称和题型
				this.$set(this.formParameter, 'name', res.data.name)
				this.$set(this.formParameter, 'type', res.data.type)
			})
		}, clearKw() {
			this.formParameter = { answer: '', type: 5, reference: '面试题' }
			this.keyword = ""
		},

		//打开弹框b
		open(parameter, title, disabled, size) {
			this.parameter = parameter;

			this.title = title;
			this.disabled = disabled;
			this.bjdisabled = disabled;
			if (title == '编辑') {
				this.bjdisabled = !disabled;
			}

			this.$refs.popup.open(title, size);
			this.$nextTick(() => {
				this.init();
			});
		},
		treeClick(data) {
			this.subData = data;
		},
		selectSub() {

			if (this.permissionList == [] || this.permissionList.length == 0) {
				subApi.list({}, (response) => {
					this.permissionList = response.data;
				});
			}

			this.dialogVisibleKm = true;
		},
		comfirmSub() {

			this.formParameter.sbname = this.subData.name;
			this.formParameter.sbid = this.subData.id;

			api.listDoces({ kid: this.formParameter.sbid }, res => {
				this.doces = res.data
				console.log("res", res);
			})

			this.dialogVisibleKm = false;

		},
		//关闭弹框
		close() {
			this.disabled = false;
			this.bjdisabled = false;
			this.$refs.popup.close();
			this.options = [
				{ o: 'A', n: '' },
				{ o: 'B', n: '' },
				{ o: 'C', n: '' },
				{ o: 'D', n: '' }];
			this.checkList = [];
			this.answerNum = [
				{ o: '1', n: '' }
			]

		}, reset() {

			this.options = [
				{ o: 'A', n: '' },
				{ o: 'B', n: '' },
				{ o: 'C', n: '' },
				{ o: 'D', n: '' }];
			this.checkList = [];
			this.answerNum = [
				{ o: '1', n: '' }
			];
			this.popupLoading = false;
			//清除等待
			this.confirmLoading = false;
			//清空内容
			this.formParameter = { answer: '', sbname: this.formParameter.sbname, sbid: this.formParameter.sbid, type: this.formParameter.type, reference: this.formParameter.reference };
			//清楚校验
			this.$refs.form.clearValidate();
		},
		//提交表单
		confirm() {
			this.$utils.checkForm(this.$refs.form, () => {
				this.confirmLoading = true;
				if (this.formParameter.type == 1 || this.formParameter.type == 2) {
					this.formParameter.content = JSON.stringify({ "title": this.formParameter.name, "choiceList": this.options });
				}
				else if (this.formParameter.type == 4) {
					this.formParameter.content = JSON.stringify({ "title": this.formParameter.name, "choiceList": this.answerNum });
				}
				else {
					this.formParameter.content = JSON.stringify({ "title": this.formParameter.name, "choiceList": {} });
				}
				if (!this.parameter.id) {
					//添加

					let parameter = this.$utils.merger(this.formParameter);
					//console.log(this.answerNum)
					//填空题
					if (parameter.type == 4) {
						handleTypeFourLogic.call(this, parameter);
					}
					//console.log(parameter);
					api.save(
						parameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.reset();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				} else {
					//编辑
					let parameter = this.$utils.merger(this.formParameter);
					if (parameter.type == 4) {
						handleTypeFourLogic.call(this, parameter);
					}
					api.update(parameter,
						success => {
							this.$utils.msg.success(success.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						fail => {
							this.$utils.msg.warning(fail.msg);
							this.confirmLoading = false;
						}
					);
				}
				function handleTypeFourLogic(parameter) {
					let answer = { isSort: this.formParameter.isSort, anwrs: [] };
					for (let i = 0; i < this.answerNum.length; i++) {
						answer.anwrs.push(this.answerNum[i].n);
					}
					parameter.answer = answer;
				}
			});
		},
		init() {

			this.popupLoading = true;
			//清除等待
			this.confirmLoading = false;
			//清空内容
			this.formParameter = { answer: '', type: 1, reference: '自编题' };
			//清楚校验
			this.$refs.form.clearValidate();

			if (this.parameter.id) {
				//编辑查询数据
				let parameter = {
					id: this.parameter.id
				};
				api.toUpdate(parameter, response => {
					this.formParameter = response.data;

					if (this.formParameter.sbid) {
						api.listDoces({ kid: this.formParameter.sbid }, res => {
							this.doces = res.data
						})
					}

					this.formParameter.sbname = this.parameter.sbname;
					this.options = JSON.parse(response.data.content).choiceList;
					this.answerNum = JSON.parse(response.data.content).choiceList;
					// console.log("response.data.content" , response.data.content)
					this.daAn = response.data.answer;
					this.checkList = this.daAn.split(',');
					this.popupLoading = false;

				});
			} else {
				//添加
				this.popupLoading = false;
			}
		},
		addSelectItem() {
			let len = this.options.length - 1;

			let last = this.options[len].o.charCodeAt() + 1;
			//console.log(last);
			this.options.push({ o: String.fromCharCode(last), n: '' });
			//console.log(this.options);
		},
		removeSelectItem() {
			let rc = this.options.pop();
			this.checkList.splice(this.checkList.indexOf(rc), 1);
		},

	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';

.content-html {
	border: 1px solid #c9d8db !important;
	padding: 0px 20px;
}
</style>

<style lang="scss">
.agent-sync-dialog .el-textarea__inner {
	min-height: 120px;
}
</style>